import { initializeApp } from "firebase/app";
import {
  getAuth,
  initializeAuth,
  indexedDBLocalPersistence,
} from "firebase/auth";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
  CustomProvider,
} from "firebase/app-check";
import { FirebaseAppCheck } from "@capacitor-firebase/app-check";
import { Capacitor } from "@capacitor/core";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDA50aQbwBfCVKcODBdCott631O79JF6AY",
  authDomain: "one-address-53a06.firebaseapp.com",
  projectId: "one-address-53a06",
  storageBucket: "one-address-53a06.firebasestorage.app",
  messagingSenderId: "683397880126",
  appId: "1:683397880126:web:4aea96f2ed9e79d175746f",
  measurementId: "G-RPTCQ13BY2",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
// Native platforms need initializeAuth() with indexedDBLocalPersistence so
// signInWithCredential() (used to bridge @capacitor-firebase/authentication's
// native sign-in results into this JS SDK instance) works correctly - see
// SignIn.js. getAuth() alone doesn't persist sessions reliably in a Capacitor
// WebView.
const auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app);
// On native (Capacitor WebView), force Firestore's long-polling transport. The
// default streaming (WebChannel) transport is unreliable inside iOS WKWebView -
// single getDoc/setDoc work, but one-shot query getDocs (e.g. the home
// dashboard's hosted/joined events list, and collectionGroup queries) can
// silently fail, so events showed on Android but not iPhone. Long-polling works
// on every platform; the minor efficiency cost is irrelevant for this app.
const db = Capacitor.isNativePlatform()
  ? initializeFirestore(app, { experimentalForceLongPolling: true })
  : getFirestore(app); // Firestore service

// App Check (abuse protection): verifies requests come from the genuine app.
//
// MONITORING-SAFE: initialising App Check does NOT block anything on its own -
// requests without a valid token are just counted as "unverified" in the
// Firebase console until you turn on *Enforcement* per service. Do NOT enable
// enforcement until a build with App Check is widely adopted and the console
// shows real traffic passing, or you'll lock out users on older versions.
//
// Web uses reCAPTCHA v3 (needs RECAPTCHA_V3_SITE_KEY from the console). Native
// uses Play Integrity (Android) / App Attest (iOS) via @capacitor-firebase/
// app-check, bridged into the JS SDK with a CustomProvider so the WebView's
// Firestore/Functions calls carry the token. Everything is wrapped so an App
// Check failure can never break the app (it just means no token -> unverified).
// See BACKLOG.md for the console/registration steps.
// reCAPTCHA Enterprise site key / key ID (public - safe to commit) for the web
// App Check provider. Created in Google Cloud reCAPTCHA (Fraud Defense); the
// Firebase web app must be registered with the "reCAPTCHA Enterprise" provider
// using this key. No secret key is needed for Enterprise. NOTE: you do NOT need
// to manually "instrument web pages" - App Check's provider handles that.
const RECAPTCHA_ENTERPRISE_SITE_KEY =
  "6LeLFKAtAAAAACBIsJVpuKfnQVX62o3FPOEwyOMv";

async function setupAppCheck() {
  try {
    if (Capacitor.isNativePlatform()) {
      await FirebaseAppCheck.initialize({ isTokenAutoRefreshEnabled: true });
      initializeAppCheck(app, {
        provider: new CustomProvider({
          getToken: () => FirebaseAppCheck.getToken(),
        }),
        isTokenAutoRefreshEnabled: true,
      });
    } else if (RECAPTCHA_ENTERPRISE_SITE_KEY) {
      initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider(
          RECAPTCHA_ENTERPRISE_SITE_KEY,
        ),
        isTokenAutoRefreshEnabled: true,
      });
    }
  } catch (err) {
    console.error("App Check setup failed (continuing without it):", err);
  }
}
setupAppCheck();

// Export Firebase services
export { auth, db, firebaseConfig };
